// セッションストレージのキー定数
export const ORIGINAL_URL_KEY = "oidc_original_url";

// ユーティリティ関数

/**
 * 元のURLを保存
 */
export const saveOriginalUrl = (url: string): void => {
  try {
    sessionStorage.setItem(ORIGINAL_URL_KEY, url);
  } catch (error) {
    console.error("❌ Failed to save original URL:", error);
  }
};

/**
 * 元のURLを取得
 */
export const getOriginalUrl = (): string | null => {
  try {
    return sessionStorage.getItem(ORIGINAL_URL_KEY);
  } catch (error) {
    console.error("❌ Failed to get original URL:", error);
    return null;
  }
};

/**
 * 元のURLを削除
 */
export const clearOriginalUrl = (): void => {
  try {
    sessionStorage.removeItem(ORIGINAL_URL_KEY);
  } catch (error) {
    console.error("❌ Failed to clear original URL:", error);
  }
};
